import React from 'react';
import { Link } from 'react-router-dom';
var moment = require('moment');
const Grid = (props) => {
    let dataLeagues = props.raw.leagues ? props.raw.leagues : [];
    let leagues = Object.keys(dataLeagues);
    let count = 0;


    leagues = leagues.map(leagueId => {
        let leagueName = props.language(dataLeagues[leagueId].sportName).text + ' - ' + dataLeagues[leagueId].countryName + ' ' + dataLeagues[leagueId].name;
        // let liganombre = leagueName;
        let dataMatches = dataLeagues[leagueId].matches ? dataLeagues[leagueId].matches : {};
        let matches = Object.keys(dataMatches).map(matchId => {

            let y = dataMatches[matchId];

            let datalocal1 = {
                choose: 1,
                id: y.idmatch + '89' + (y.data[19992] ? y.data[19992].type : (y.data[39991] ? y.data[39991].type : "")) + '791',
                logro: y.data[19992] ? y.data[19992].logro : (y.data[39991] ? y.data[39991].logro : ""),
                idmatch: y.idmatch,
                name: y.name,
                odd: props.format(y.data[19992] ? y.data[19992].o1 : (y.data[39991] ? y.data[39991].o1 : "")),
                option: y.home,
                price: y.data[19992] ? y.data[19992].o1 : (y.data[39991] ? y.data[39991].o1 : ""),
                time: y.timestamp,
                type: y.data[19992] ? y.data[19992].type : (y.data[39991] ? y.data[39991].type : ""),
                version: y.data[19992] ? y.data[19992].version : (y.data[39991] ? y.data[39991].version : ""),
                liga: leagueName,
            };
            let dataempatex = {
                choose: 2,
                id: y.idmatch + '89' + (y.data[19992] ? y.data[19992].type : (y.data[39991] ? y.data[39991].type : "")) + '792',
                logro: y.data[19992] ? y.data[19992].logro : "",
                idmatch: y.idmatch,
                name: y.name,
                odd: props.format( y.data[19992] ? y.data[19992].o2 : ""),
                option: "draw",
                price: y.data[19992] ? y.data[19992].o2 : "",
                time: y.timestamp,
                type: y.data[19992] ? y.data[19992].type : "",
                version: y.data[19992] ? y.data[19992].version : "",
                liga: leagueName,
            };
            let datavisitante2 = {
                choose: y.data[19992] ? 3 : (y.data[39991] ? 2 : ""),
                id: y.idmatch + '89' + (y.data[19992] ? y.data[19992].type : (y.data[39991] ? y.data[39991].type : "")) + '79' + (y.data[19992] ? '3' : (y.data[39991] ? '2' : "")),
                logro: y.data[19992] ? y.data[19992].logro : (y.data[39991] ? y.data[39991].logro : ""),
                idmatch: y.idmatch,
                name: y.name,
                odd: props.format( y.data[19992] ? y.data[19992].o3 : (y.data[39991] ? y.data[39991].o2 : "")),
                option: y.away,
                price: y.data[19992] ? y.data[19992].o3 : (y.data[39991] ? y.data[39991].o2 : ""),
                time: y.timestamp,
                type: y.data[19992] ? y.data[19992].type : (y.data[39991] ? y.data[39991].type : ""),
                version: y.data[19992] ? y.data[19992].version : (y.data[39991] ? y.data[39991].version : ""),
                liga: leagueName,
            };


            let data1x = {
                choose: 1,
                id: y.idmatch + '89' + (y.data[49992] ? y.data[49992].type : "") + '791',
                logro: y.data[49992] ? y.data[49992].logro : "",
                idmatch: y.idmatch,
                name: y.name,
                odd: props.format( y.data[49992] ? y.data[49992].o1 : ""),
                option: "1X",
                price: y.data[49992] ? y.data[49992].o1 : "",
                time: y.timestamp,
                type: y.data[49992] ? y.data[49992].type : "",
                version: y.data[49992] ? y.data[49992].version : "",
                liga: leagueName,
            };
            let data12 = {
                choose: 2,
                id: y.idmatch + '89' + (y.data[49992] ? y.data[49992].type : "") + '792',
                logro: y.data[49992] ? y.data[49992].logro : "",
                idmatch: y.idmatch,
                name: y.name,
                odd: props.format( y.data[49992] ? y.data[49992].o2 : ""),
                option: "12",
                price: y.data[49992] ? y.data[49992].o2 : "",
                time: y.timestamp,
                type: y.data[49992] ? y.data[49992].type : "",
                version: y.data[49992] ? y.data[49992].version : "",
                liga: leagueName,
            };
            let data2x = {
                choose: 3,
                id: y.idmatch + '89' + (y.data[49992] ? y.data[49992].type : "") + '793',
                logro: y.data[49992] ? y.data[49992].logro : "",
                idmatch: y.idmatch,
                name: y.name,
                odd: props.format( y.data[49992] ? y.data[49992].o3 : ""),
                option: "2X",
                price: y.data[49992] ? y.data[49992].o3 : "",
                time: y.timestamp,
                type: y.data[49992] ? y.data[49992].type : "",
                version: y.data[49992] ? y.data[49992].version : "",
                liga: leagueName,
            };


            let dataover = {
                choose: 1,
                logro: y.data[29992] ? y.data[29992].logro : (y.data[29991] ? y.data[29991].logro : ""),
                id: y.idmatch + '89' + (y.data[29992] ? y.data[29992].type : (y.data[29991] ? y.data[29991].type : "")) + '791',
                idmatch: y.idmatch,
                name: y.name,
                odd: props.format( y.data[29992] ? y.data[29992].o1 : (y.data[29991] ? y.data[29991].o1 : "")),
                handicap: y.data[29992] ? y.data[29992].o3 : (y.data[29991] ? y.data[29991].o3 : ""),
                option: 'over',
                price: y.data[29992] ? y.data[29992].o1 : (y.data[29991] ? y.data[29991].o1 : ""),
                time: y.timestamp,
                type: y.data[29992] ? y.data[29992].type : (y.data[29991] ? y.data[29991].type : ""),
                version: y.data[29992] ? y.data[29992].version : (y.data[29991] ? y.data[29991].version : ""),
                liga: leagueName,
            };
            let dataunder = {
                choose: 2,
                id: y.idmatch + '89' + (y.data[29992] ? y.data[29992].type : (y.data[29991] ? y.data[29991].type : "")) + '792',
                logro: y.data[29992] ? y.data[29992].logro : (y.data[29991] ? y.data[29991].logro : ""),
                idmatch: y.idmatch,
                name: y.name,
                odd: props.format( y.data[29992] ? y.data[29992].o2 : (y.data[29991] ? y.data[29991].o2 : "")),
                handicap: y.data[29992] ? y.data[29992].o3 : (y.data[29991] ? y.data[29991].o3 : ""),
                option: 'under',
                price: y.data[29992] ? y.data[29992].o2 : (y.data[29991] ? y.data[29991].o2 : ""),
                time: y.timestamp,
                type: y.data[29992] ? y.data[29992].type : (y.data[29991] ? y.data[29991].type : ""),
                version: y.data[29992] ? y.data[29992].version : (y.data[29991] ? y.data[29991].version : ""),
                liga: leagueName,
            };

            return <div key={matchId} className="row m-0 pl-0 match-list">
                {/* <Link to={"event/" + matchId} className="d-inline-flex"> */}
                <div className="col-md-5 col-lg-4 col-xl-2 border border-right-0 border-bottom-0 border-left-0 border-info p-2 pl-3 pt-3 d-flex justify-content-between">

                    <div className="text" style={{ textAlign: 'left' }}>
                        <p className="meta">
                            <span className="matchinfo">
                                <span className="block">{moment(dataMatches[matchId].timestamp * 1000).calendar()}</span>
                                <span className="block">
                                    <b className="pt-intent-green-text">{props.language('sheduled').text}</b>
                                </span>
                            </span>
                        </p>
                        <h3>
                            <Link to={"/event/" + matchId}>{dataMatches[matchId].name}</Link>
                        </h3>
                        <p className="league">

                            <span>{leagueName}</span>
                        </p>

                    </div>
                    <Link to={"/event/" + matchId} className="totalmarkets d-flex d-md-none badge badge-success text-white" >+{dataMatches[matchId].more}</Link>
                </div>
                {/* </Link> */}
                <div className="col-md-7 col-lg-8 col-xl-10 p-0 pb-4">
                    <div className="row m-0 pt-3 border border-right-0 border-bottom-0 border-left-0 border-info">

                        <div className={(y.data[19992] || y.data[39991]) ? (y.data[49992] ? "col-md-10 col-xl-4" : "col-lg-10 col-xl-6") : "d-none"}>
                            <span className={(y.data[19992] || y.data[39991]) ? "event-header" : "d-none"} style={{ top: -23 }}>
                                <span className="text-success">{y.data[19992] ? "1X2" : "Moneyline"}</span>
                            </span>
                            <div className="row">
                                <div className={(y.data[19992]) ? "col-sm-4 p-1" : "col-sm-6 p-1"}>
                                    <button
                                        className={(y.data[19992] || y.data[39991]) ? (props.items[datalocal1.id] ? "button-special border border-success active" : "button-special border border-success") : "button-special border border-success disabled"}
                                        onClick={(y.data[19992] || y.data[39991]) ? props.addTocart.bind(this, datalocal1) : void 0}>
                                        <span className="text pb-1"> {(y.data[19992] || y.data[39991]) ? datalocal1.odd : ""}</span>
                                        <span className="odds animate text-truncate text-" >{dataMatches[matchId].home}</span>
                                    </button>
                                </div>
                                <div className={(y.data[19992]) ? "col-sm-4 p-1" : "col-sm-0 d-none"}>
                                    <button id={dataempatex.id}
                                        className={(y.data[19992] || y.data[39991]) ? (props.items[dataempatex.id] ? "button-special border border-success active" : "button-special border border-success") : "button-special border border-success disabled"}
                                        onClick={y.data[19992] ? props.addTocart.bind(this, dataempatex) : void 0}>
                                        <span className="text pb-1">{(y.data[19992]) ? dataempatex.odd : ""}</span>
                                        <span className="odds animate">{(y.data[19992]) ? props.language('draw').text : ""}</span>
                                    </button>
                                </div>
                                <div className={(y.data[19992]) ? "col-sm-4 p-1" : "col-sm-6 p-1"}>
                                    <button id={datavisitante2.id}
                                        className={(y.data[19992] || y.data[39991]) ? (props.items[datavisitante2.id] ? "button-special border border-success active" : "button-special border border-success") : "button-special border border-success disabled"}
                                        onClick={(y.data[19992] || y.data[39991]) ? props.addTocart.bind(this, datavisitante2) : void 0}>
                                        <span className="text pb-1"> {(y.data[19992] || y.data[39991]) ?datavisitante2.odd : ""}</span>
                                        <span className="odds animate text-truncate">{dataMatches[matchId].away}</span>
                                    </button>
                                </div>

                            </div>
                        </div>
                        <div className={(y.data[29992] || y.data[29991]) ? (y.data[49992] ? "col-md-0 col-xl-3 d-none d-xl-block" : "col-md-0 col-xl-5 d-none d-xl-block") : "d-none"}>
                            <span className={(y.data[29992] || y.data[29991]) ? "event-header d-none d-xl-flex" : "d-none"} style={{ top: -23 }} >
                                <span className="text-warning">O/U</span>
                            </span>
                            <div className="row">
                                <div className="col-lg-6 p-1 d-none d-xl-block">
                                    <button
                                        className={(y.data[29992] || y.data[29991]) ? (props.items[dataover.id] ? "button-special border border-warning active" : "button-special border border-warning") : "button-special border border-warning disabled"}
                                        onClick={(y.data[29992] || y.data[29991]) ? props.addTocart.bind(this, dataover) : void 0}>
                                        <span className="text pb-1">   {(y.data[29992] || y.data[29991]) ? dataover.odd : ""}</span>
                                        <span className="odds animate text-warning text-truncate">{props.language(dataover.option).text}  {dataover.handicap}</span>
                                    </button>
                                </div>
                                <div className="col-lg-6 p-1 d-none d-xl-block">
                                    <button
                                        className={(y.data[29992] || y.data[29991]) ? (props.items[dataunder.id] ? "button-special border border-warning active" : "button-special border border-warning") : "button-special border border-warning disabled"}
                                        onClick={(y.data[29992] || y.data[29991]) ? props.addTocart.bind(this, dataunder) : void 0}>
                                        <span className="text pb-1" >{(y.data[29992] || y.data[29991]) ? dataunder.odd : ""}</span>
                                        <span className="odds animate text-warning text-truncate" >{props.language(dataunder.option).text} {dataunder.handicap}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className={y.data[49992] ? "col-md-0 col-xl-4 d-none d-xl-block" : "d-none"}>
                            <span className="event-header" style={{ top: -23 }}>
                                <span className="text-primary">Doble Chance</span>
                            </span>
                            <div className="row">
                                <div className="col-sm-4 p-1">
                                    <button
                                        className={y.data[49992] ? (props.items[data1x.id] ? "button-special border border-primary active" : "button-special border border-primary") : "button-special border border-primary disabled"}
                                        onClick={y.data[49992] ? props.addTocart.bind(this, data1x) : void 0}>
                                        <span className="text pb-1"> {y.data[49992] ? data1x.odd : ""}</span>
                                        <span className="odds animate text-primary">1X</span>
                                    </button>
                                </div>
                                <div className="col-sm-4 p-1">
                                    <button
                                        className={y.data[49992] ? (props.items[data12.id] ? "button-special border border-primary active" : "button-special border border-primary") : "button-special border border-primary disabled"}
                                        onClick={y.data[49992] ? props.addTocart.bind(this, data12) : void 0}>
                                        <span className="text pb-1">{y.data[49992] ?data12.odd : ""}</span>
                                        <span className="odds animate text-primary">12</span>
                                    </button>
                                </div>
                                <div className="col-sm-4 p-1">
                                    <button
                                        className={y.data[49992] ? (props.items[data2x.id] ? "button-special border border-primary active" : "button-special border border-primary") : "button-special border border-primary disabled"}
                                        onClick={y.data[49992] ? props.addTocart.bind(this, data2x) : void 0}>
                                        <span className="text pb-1"> {y.data[49992] ? data2x.odd : ""}</span>
                                        <span className="odds animate text-primary">X2</span>
                                    </button>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-2 col-xl-1 p-1 d-none d-md-block mt-3">

                            <Link to={"/event/" + matchId} className=" btn btn-dark bg-dark">
                                <span className=" totalmarkets text pb-1 m-0 mt-1" href="0">+{dataMatches[matchId].more} <i className="fas fa-angle-right"></i>
                                </span>
                            </Link>
                        </div>

                    </div>
                </div>

            </div>

        })

        return <div key={leagueId} className="card sports-highlights">
            <div className="card-header" id={"H" + leagueId}>
                <a data-toggle="collapse" data-parent="#accordionExample" href={"#F" + leagueId} aria-expanded="true" aria-controls={"F" + leagueId}>
                    <h6 className="mb-0 white-text font-thin d-flex justify-content-between" style={{ textAlign: 'left' }}>
                        <span>
                            <i className={"ficon-inline f-" + dataLeagues[leagueId].country}></i>
                            {leagueName}
                        </span>
                        <i className="fa fa-angle-down rotate-icon"></i>
                    </h6>
                </a>
            </div>
            <div id={"F" + leagueId} className={count < 4 ? "collapse show" : "collapse"} aria-labelledby={"H" + leagueId} data-parent="#accordionExample">
                <div className="card-body p-0">
                    <div className="pt-3"></div>
                    {matches}
                </div>
            </div>
        </div>

    });

    return leagues;
}
export default Grid;


// WEBPACK FOOTER //
// ./src/components/Grid.js